import React from 'react';
import { Link } from 'react-router-dom';
const footerLinks: Record<string, {
  label: string;
  path: string;
}[]> = {
  Product: [{
    label: 'Overview',
    path: '/product'
  }, {
    label: 'For Artists & Bands',
    path: '/for-artists'
  }, {
    label: 'For Venues & Promoters',
    path: '/for-venues'
  }, {
    label: 'For Agents & Managers',
    path: '/for-agents'
  }, {
    label: 'Discovery & Routing',
    path: '/discovery'
  }, {
    label: 'Deals & Contracts',
    path: '/deals-contracts'
  }, {
    label: 'AI Assistant',
    path: '/ai-assistant'
  }],
  Solutions: [{
    label: 'Touring Artists',
    path: '/for-artists'
  }, {
    label: 'Boutique Agencies',
    path: '/for-agents'
  }, {
    label: 'Independent Venues',
    path: '/for-venues'
  }, {
    label: 'Lineup & Tour Ops',
    path: '/lineup-ops'
  }, {
    label: 'Pricing',
    path: '/pricing'
  }],
  Resources: [{
    label: 'Book a Demo',
    path: '/demo'
  }, {
    label: 'Contact Sales',
    path: '/contact-sales'
  }, {
    label: 'Contact',
    path: '/contact'
  }],
  Company: [{
    label: 'Security',
    path: '/security'
  }, {
    label: 'Privacy',
    path: '/privacy'
  }, {
    label: 'Terms',
    path: '/terms'
  }]
};
export function Footer() {
  return <footer className="border-t border-border bg-surface/30" data-id="element-330">
      <div className="max-w-7xl mx-auto px-6 py-16" data-id="element-331">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10" data-id="element-332">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1" data-id="element-333">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-334">
              <span className="text-xl font-bold text-textMain" data-id="element-335">Booker</span>
              <div className="w-1.5 h-1.5 rounded-full bg-primary" data-id="element-336"></div>
            </Link>
            <p className="text-sm text-textMuted leading-relaxed mb-6" data-id="element-337">
              The booking operating system for live performance.
            </p>
            <div className="flex gap-4" data-id="element-338">
              <a href="#" className="text-textMuted hover:text-textMain transition-colors" aria-label="Twitter" data-id="element-339">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-340">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-341" />
                </svg>
              </a>
              <a href="#" className="text-textMuted hover:text-textMain transition-colors" aria-label="LinkedIn" data-id="element-342">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-343">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-344" />
                </svg>
              </a>
              <a href="#" className="text-textMuted hover:text-textMain transition-colors" aria-label="Instagram" data-id="element-345">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-346">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-347" />
                </svg>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([category, links]) => <div key={category} data-id="element-348">
              <h4 className="text-sm font-semibold text-textMain mb-4" data-id="element-349">
                {category}
              </h4>
              <ul className="flex flex-col gap-2.5" data-id="element-350">
                {links.map(link => <li key={link.label} data-id="element-351">
                    <Link to={link.path} className="text-sm text-textMuted hover:text-textMain transition-colors" data-id="element-352">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-textMuted" data-id="element-353">
          <span data-id="element-354">© 2026 Booker. All rights reserved.</span>
          <div className="flex gap-6" data-id="element-355">
            <Link to="/privacy" className="hover:text-textMain transition-colors" data-id="element-356">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-textMain transition-colors" data-id="element-357">
              Terms of Service
            </Link>
            <Link to="/security" className="hover:text-textMain transition-colors" data-id="element-358">
              Security
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}